import moment from 'moment';
import VueFormGenerator from 'vue-form-generator';

export default {
  schema: {
    fields: [
      {
        type: 'radios',
        label: 'Do you have any outstanding debt on this property?',
        model: 'debt',
        styleClasses: 'col-md-12 bool-radio',
        required: true,
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        onChanged(model, newVal) {
          if (!newVal) {
            /* eslint no-param-reassign: ["error", { "props": false }] */
            model.liens = null;
          }
        },
      },
      {
        type: 'array',
        label: 'Liens',
        model: 'liens',
        showRemoveButton: true,
        styleClasses: 'col-md-12',
        itemContainerClasses: 'pb-2 lien-item-container',
        itemFieldClasses: 'item-field-class',
        newElementButtonLabelClasses: 'btn btn-info mt-2',
        removeElementButtonClasses: 'btn btn-danger remove-item-btn',
        newElementButtonLabel: '+ Add Lien',
        items: {
          type: 'object',
          default: {},
          schema: {
            fields: [
              {
                type: 'currency',
                model: 'price',
                attributes: {
                  input: { 'data-lpignore': 'true' },
                },
                required: true,
                styleClasses: 'col-md-4',
                validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
              },
              {
                type: 'fancyCheckbox',
                text: 'Payoff Lien with new Loan from Anchor',
                model: 'payoff',
                styleClasses: 'col-md-8',
              },
            ],
          },
        },
        visible(model) {
          return model && model.debt === true;
        },
      },
      {
        type: 'currency',
        label: 'Original Purchase Price',
        model: 'price',
        required: true,
        styleClasses: 'col-md-12',
        validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
      },
      {
        type: 'currency',
        label: 'What is the current value of the property?',
        model: 'asIsValue',
        required: true,
        styleClasses: 'col-md-12',
        validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
      },
      {
        type: 'datePicker',
        label: 'What is your required closing date?',
        model: 'closingDate',
        required: true,
        styleClasses: 'col-md-12',
        options: {
          onlyDate: true,
          format: 'MM/DD/YYYY',
          formatted: 'll',
          color: '#3e88c9',
          buttonColor: '#3e88c9',
          minDate: moment().format('MM/DD/YYYY'),
          autoClose: true,
          label: 'Select Date',
        },
        validator: VueFormGenerator.validators.date,
      },
      {
        type: 'select',
        label: 'What is your exit strategy?',
        model: 'exitStrategy',
        required: true,
        selectOptions: {
          noneSelectedText: '-',
        },
        values: [
          { id: 'Sale', name: 'Sale' },
          { id: 'Refinance', name: 'Refinance' },
        ],
        validator: VueFormGenerator.validators.required,
      },
    ],
  },
  formOptions: {
    validationErrorClass: 'invalid-input',
    validateAfterChanged: true,
    fieldIdPrefix: 'refinance-',
  },
};



// WEBPACK FOOTER //
// ./src/components/new_deal/components/refinance/schema.js